import "./App.css";
import nave from "./assets/nave";
import primero_lee from "./assets/primero_lee_logo";

function App() {
  return (
    <div className="App">
      <div>
        <img src={primero_lee} className="logo" alt="primero lee" />
      </div>
      <div>
        <img src={nave} className="nave" alt="Nave" />
      </div>
      <div className="policyText">
        <h1 style={{ textAlign: "center" }}>Política de Privacidad</h1>
        <p>
          Fundación Crecer, representada para estos efectos por Loreto Iglesias,
          creó la aplicación Primero LEE, por medio de la cual los usuarios
          podrán practicar las habilidades de lectoescritura sin necesidad de
          estar conectados a internet. Para mayores detalles respecto a los
          servicios que son entregados por medio de la aplicación puede revisar
          nuestros términos y condiciones.
        </p>
        <p>
          La aplicación Primero Lee es proporcionada de forma gratuita para los
          usuarios.
        </p>
        <p>
          Los usuarios de los servicios ofrecidos a través de la aplicación
          Primero Lee deberán aceptar la presente Política de Privacidad antes
          de utilizar la aplicación, en conformidad a la ley chilena 19.628, la
          cual viene a informar y transparentar a los usuarios las finalidades
          del tratamiento de los datos personales, quién será el responsable del
          mismo, las formas en qué podrán ejercer sus derechos, entre otros
          detalles que podrían ser relevantes para entender el tratamiento y
          otorgar un consentimiento libre e informado. En el caso de usuarios
          menores de edad, especialmente en relación a niños y niñas menores de
          16 años, la autorización deberá ser otorgada por ambos padres o por
          sus tutores legales según corresponda, lo cual el usuario garantiza.
        </p>
        <h2>Recopilación y uso de información</h2>
        <p>
          Para una mejor experiencia, mientras utiliza nuestro Servicio, es
          posible que le solicitemos que nos proporcione cierta información de
          identificación personal. La información que solicitamos será retenida
          por nosotros y utilizada sólo para fines estadísticos.
        </p>
        <p>
          Asimismo, la información personal que recopilamos se utiliza para
          proporcionar y mejorar los servicios detallados en nuestros términos y
          condiciones.
        </p>
        <h2>Datos de registro</h2>
        <p>
          Queremos informarle que cada vez que utiliza nuestro Servicio, en caso
          de un error en la aplicación, recopilamos datos e información (a
          través de productos de terceros) en su teléfono llamado Datos de
          registro. Estos Datos de registro pueden incluir información como la
          dirección de Protocolo de Internet ("IP") de su dispositivo, el nombre
          del dispositivo, la versión del sistema operativo, la configuración de
          la aplicación cuando utiliza nuestro Servicio, la hora y fecha de su
          uso del Servicio y otras estadísticas.
        </p>
        <h2>Cookies</h2>
        <p>
          Las cookies son archivos con una pequeña cantidad de datos que se
          utilizan comúnmente como identificadores únicos anónimos. Estos se
          envían a su navegador desde los sitios web que visita y se almacenan
          en la memoria interna de su dispositivo.
        </p>
        <p>
          Este Servicio no utiliza estas "cookies" explícitamente. Sin embargo,
          la aplicación puede utilizar códigos de terceros y bibliotecas que
          utilizan "cookies" para recopilar información y mejorar sus servicios.
          Tiene la opción de aceptar o rechazar estas cookies y saber cuándo se
          envía una cookie a su dispositivo. Si opta por rechazar nuestras
          cookies, es posible que no pueda utilizar algunas partes de este
          Servicio.
        </p>
        <h2>Terceros que pueden requerir su información</h2>
        <p>
          La aplicación utiliza servicios de terceros que pueden recopilar
          información utilizada para identificarlo, tales como Google Play (cuya
          política de privacidad puede encontrarse en{" "}
          <a href="https://protect-us.mimecast.com/s/fYlTCmZMG0c9EVVSOd5n5?domain=google.com/">
            https://protect-us.mimecast.com/s/fYlTCmZMG0c9EVVSOd5n5?domain=google.com/
          </a>
          ).
        </p>
        <p>
          Asimismo, nuestra aplicación puede contener enlaces a otros sitios. Si
          hace clic en un enlace de un tercero, se le dirigirá a ese sitio.
          Tenga en cuenta que estos sitios externos no son operados por
          nosotros. Por lo tanto, le recomendamos encarecidamente que revise la
          Política de privacidad de estos sitios web. No tenemos control ni
          asumimos ninguna responsabilidad por el contenido, las políticas de
          privacidad o las prácticas de los sitios o servicios de terceros.
        </p>
        <p>
          <strong>Terceros con quienes podemos compartir la información</strong>
        </p>
        <p>
          Por nuestra parte, es posible que empleemos a terceros, empresas e/o
          individuos, por las siguientes razones:
        </p>
        <p>• Para facilitar nuestro Servicio</p>
        <p>• Para proporcionar el Servicio en nuestro nombre</p>
        <p>• Para realizar servicios relacionados con el Servicio</p>
        <p>• Para ayudarnos a analizar cómo se utiliza nuestro Servicio</p>
        <p>
          Queremos informar a los usuarios de este Servicio que estos terceros
          pueden tener acceso a su Información personal en calidad de
          procesadores, por lo que aquellos no estarán autorizados a utilizar ni
          divulgar sus datos personales para ningún otro propósito.
        </p>
        <h2>Seguridad</h2>
        <p>
          Valoramos su confianza al proporcionarnos su información personal, por
          lo que nos esforzamos por utilizar medios comercialmente aceptables
          para protegerla. Pero recuerde que ningún método de transmisión a
          través de Internet o método de almacenamiento electrónico es 100%
          seguro y confiable, y no podemos garantizar su absoluta seguridad.
        </p>
        <h2>Privacidad de los niños</h2>
        <p>
          Estos Servicios no se dirigen a ninguna persona menor de 13 años. No
          recopilamos a sabiendas información de identificación personal de
          niños menores de 13 años. En el caso de que descubramos que un niño
          menor de 13 años nos ha proporcionado información personal, la
          eliminamos inmediatamente de nuestros servidores. Si usted es padre o
          tutor y sabe que su hijo nos ha proporcionado información personal,
          comuníquese con nosotros para que podamos realizar las acciones
          necesarias.
        </p>
        <h2>Cambios a esta política de privacidad</h2>
        <p>
          Es posible que actualicemos nuestra Política de privacidad de vez en
          cuando. Por lo tanto, le notificaremos de cualquier cambio publicando
          la nueva Política de privacidad en esta página, y por medio de sus
          datos de contacto.
        </p>
        <h2>Derechos del Usuario</h2>
        <p>
          En el caso de que el Usuario requiera hacer ejercicio de los derechos
          de acceso, rectificación, cancelación u oposición, que emanan de la
          ley chilena sobre protección de la vida privada, al tratamiento de sus
          datos personales por la Fundación Crecer, podrá contactarnos a través
          del correo electrónico{" "}
          <a href="mailto:primeroleeapp@fundacioncrecer.net">
            primeroleeapp@fundacioncrecer.net
          </a>
          , señalando el asunto “App Primero LEE” e indicando en el mensaje con
          claridad los derechos que se buscan ejercer. Si tiene alguna pregunta
          o sugerencia sobre nuestra Política de Privacidad, no dude en
          contactarnos en primeroleeapp@fundacioncrecer.net.
        </p>
        <h2>Retención de los Datos</h2>
        <p>
          Conservaremos sus datos personales por el tiempo que sea necesario
          para prestar adecuadamente nuestros servicios y poder mejorar su
          experiencia como usuario entendiendo sus necesidades. Le recordamos
          que el consentimiento que nos brinda para tener acceso a sus datos de
          carácter personal, siempre puede ser revocado de forma escrita, sin
          perjuicio de que aquella no será retroactiva y de otras bases de
          legitimidad que pueda tener Fundación Crecer. Para ello, podrás
          contactarte con nosotros a través del través del correo electrónico
          primeroleeapp@fundacioncrecer.net señalando el asunto “Revocar correo
          XXX” . Debe tener en cuenta que, en caso que el acceso que tenemos a
          sus datos personales sea revocado, no podremos brindarle atención
          personalizada sobre nuestros servicios, ya que no contaremos con la
          información necesaria para poder ejecutarlo.
        </p>
      </div>
    </div>
  );
}

export default App;
